export default __webpack_public_path__ + "b64a1920d12b5d98424dd39bd96d5cb0.svg";